module.exports = __webpack_public_path__ + "img/je.jecc06b8c.svg";